/*
 * 初始化 cookie 插件
 * by sunxingfan
 */
/*
 * @method cookie       读取、删除或设置 cookie
 * @param  {String} key 设置或读取的cookie name
 * @param  {String} v   设置的cookie value
 * @param  {Object} o   有效期、路径等
 * @return {Object} document.cookie
 * <pre>
 * setCookie('cookieName'); //读取Cookie值
 * setCookie('cookieName', 'cookieValue'); //设置cookie的值
 * setCookie('cookieName', 'cookieValue', {expires: 7, path: '/', domain: 'mi.com', secure: true});
 * //新建一个cookie 包括有效期 路径 域名等
 * setCookie('cookieName', 'cookieValue'); //新建cookie
 * setCookie('cookieName', null); //删除一个cookie
 * </pre>
 */
/* global BE: false */

export default function setCookie(...args) {
  const key = args[0];
  let value = args[1];
  const o = args[2];
  let options;

  if (args.length > 1 && String(value) !== '[object Object]') {
    let days;
    let t;
    options = jQuery.extend({}, o);

    if (value === null || value === undefined) {
      options.expires = -1;
    }

    if (typeof options.expires === 'number') {
      days = options.expires;
      t = options.expires = new Date();

      t.setDate(t.getDate() + days);
    }

    value = String(value);
    return (document.cookie = [
      encodeURIComponent(key), '=',
      options.raw ? value : encodeURIComponent(value),
      options.expires ? `; expires=${options.expires.toUTCString()}` : '',
      options.path ? `; path=${options.path}` : '',
      options.domain ? `; domain=${options.domain}` : '',
      options.secure ? '; secure' : '',
    ].join(''));
  }

  options = value || {};
  const decode = !options.raw ? decodeURIComponent : function decode(s) {
    return s;
  };
  const result = new RegExp(`(?:^|; )${encodeURIComponent(key)}=([^;]*)`).exec(document.cookie);

  return result ? decode(result[1]) : null;
}



// WEBPACK FOOTER //
// ./src/libs/setCookie.js